module.exports = __webpack_public_path__ + "img/3-2.b9f8a970.jpg";